var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SnapStar_svg__clip0_4775_12366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.464 9.536a5 5 0 107.072-7.071 5 5 0 00-7.072 7.07z",
    fill: "#FFE300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.464 2.464a5 5 0 000 7.072l7.072-7.072a5 5 0 00-7.072 0z",
    fill: "#FFFC80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.75,
    transform: "rotate(45 6 6)",
    stroke: "#FFE300",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SnapStar_svg__clip1_4775_12366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.464 9.465a5 5 0 107.072-7.072 5 5 0 00-7.072 7.072z",
    fill: "#FFE300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.464 2.393a5 5 0 000 7.072l7.072-7.072a5 5 0 00-7.072 0z",
    fill: "#FFFC80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5.929,
    r: 4.75,
    transform: "rotate(45 6 5.929)",
    stroke: "#FFE300",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.531 5.238a.178.178 0 00-.144-.121l-1.512-.22-.676-1.37a.178.178 0 00-.32 0l-.676 1.37-1.512.22a.178.178 0 00-.097.303l1.094 1.067-.264 1.507a.178.178 0 00.258.187l1.352-.711 1.353.71a.178.178 0 00.264-.186l-.258-1.506L8.487 5.42a.178.178 0 00.044-.183z",
    fill: "#2C3137"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SnapStar_svg__clip0_4775_12366"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SnapStar_svg__clip1_4775_12366"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 -.071)",
    d: "M0 0h12v12H0z"
  })))));
}
export default SvgSnapStar;